/* eslint-disable reverb-design-system/prefer-components-to-classname */
import React from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';

type Size = 'default' | 'small' | 'large';

interface IProps {
  /**
   * The size of the loading indicator. `small` is sized for controls like buttons and input actions.
   * Inside an RCButton (or an element styled with the `rc-button` mixins) it follows the button's
   * size, down to `mini`.
   */
  size?: Size;
}

/**
 * An animated loading indicator. The bars take the surrounding text color.
 * We don't often need to display one, but when you need to show that a section is loading and can't use placeholders with our `pulse` animation,
 * center a loading bar over the given area.
 */
export function RCLoadingBars({ size = 'default' }: IProps) {
  const classes = classNames('rc-loading-bars', {
    'rc-loading-bars--small': size === 'small',
    'rc-loading-bars--large': size === 'large',
  });

  return (
    <span
      className={classes}
      role="img"
      aria-label={I18n.t('cadence.RCLoadingBars.ariaLabel')}
    >
      {/* Keyed by size so a size change remounts every bar and their staggered animations restart
          in step, rather than new bars starting out of phase with ones already running. */}
      <span className="rc-loading-bars__inner" key={size}>
        {[...Array(size === 'small' ? 3 : 5)].map((_, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <span key={i} className="rc-loading-bars__bar" />
        ))}
      </span>
    </span>
  );
}
